import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIAsignacionContent } from './components/RIAsignacionContent';

export default function RIAsignacionDetalle() {
    return (
        <>
            <MainContent
                component={<RIAsignacionContent />}
                titulo='Asignar RI'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
